import { FC } from 'react'
import { Form, InputGroup, Input } from 'rsuite';

interface Meta {
  touched: boolean;
  error: string;
}

interface ComponentProps {
  input: any;
  placeholder: string;
  meta?: Meta;
  type: string;
  label?: string;
  disabled?: boolean;
  rows?: number;
  name?: string;
}

const CustomInput: FC<ComponentProps> = ({ placeholder, input, type, disabled, rows }) => (
  <Input
    placeholder={placeholder}
    {...input}
    type={type}
    autoComplete="off"
    disabled={disabled}
    as="textarea"
    rows={rows}
  />
)

const TextArea: FC<ComponentProps> = (props: ComponentProps) => {
  const { placeholder = "Input", meta, input, type = "text", label, disabled, rows = 3, name = 'text-area' } = props
  return (
    <Form.Group>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <InputGroup inside style={{ width: '100%' }}>
        <Form.Control
          accepter={CustomInput}
          placeholder={placeholder}
          input={input}
          type={type}
          name={`${name}-form-control`}
          disabled={disabled}
          rows={rows}
          errorMessage={meta?.touched && meta.error} />
      </InputGroup>
    </Form.Group>
  );
}

export default TextArea